import { render, staticRenderFns } from "./employeefrm.vue?vue&type=template&id=35db6ca8"
import script from "./employeefrm.vue?vue&type=script&lang=js"
export * from "./employeefrm.vue?vue&type=script&lang=js"
import style0 from "./employeefrm.vue?vue&type=style&index=0&id=35db6ca8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports